import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OperationFiltersState } from '@repo/accounts-types'

const initialState: OperationFiltersState = {
  operationType: undefined,
  dateFrom: undefined,
  dateTo: undefined,
}

export const {
  actions: accountsOperationsFiltersActions,
  reducer: accountsOperationsFiltersReducer,
} = createSlice({
  name: '@accounts/master/filters/operations',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<OperationFiltersState>) => {
      return { ...state, ...action.payload }
    },
    clearFilter: () => {
      return initialState
    },
  },
})
